import AuthStore from './AuthStore';
import UiStore from './UiStore';
import DesignStore from './DesignStore';

//@ts-ignore
export default () => {
  AuthStore.useStoreActions((actions) => actions.initAuth)();
  UiStore.useStoreActions((actions) => actions.initUi)();
  DesignStore.useStoreActions((actions) => actions.initDesign)();
  return null;
};
